const colors = {
	palette: {
		black1: "#252525",
		black2: "#7F8084",
		black3: "#D7D8DA",
		black4: "#F3F3F3",
		purple1: "#5328FE",
		blue1: "#16191E",
		orange1: "#F46A06",
		green1: "#8DE734",
		yellow1: "#FFE600",
		red1: "#D34141",
	},
	grayScale: {
		1: "#151515",
		2: "#2C2C2C",
		3: "#3B3B3B",
		4: "#4C4C4C",
		5: "#5B5B5B",
		6: "#6B6B6B",
		7: "#7A7A7A",
		8: "#898989",
		9: "#9A9A9A",
		10: "#AAAAAA",
		11: "#B9B9B9",
		12: "#C8C8C8",
		13: "#D7D7D7",
		14: "#F2F2F2",
		15: "#FFFFFF",
	},
}

export default colors
